module.exports = __webpack_public_path__ + "static/media/landing-animation-2.38189c2a.gif";